<div class="phone-wrapper" #phoneWrapper>
    <mat-form-field class="w-100">
        <mat-label>
            {{ label | translate }}
        </mat-label>
        <input #phoneInput matInput type="tel" class="phone-input" [formControl]="phoneNumberControl">
        <mat-error shared-form-error [control]="phoneNumberControl" [type]="'mobileNumber'">
        </mat-error>
    </mat-form-field>
</div>